export const DEFAULT_API_LIMIT = 20;
export const DEFAULT_NOTIFICATIONS_API_LIMIT = 10;
export const DEFAULT_API_OFFSET = 0;
export const ATTRIBUTE_VALUES_API_LIMIT = 500;
